var _style, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 64",
    style: {
      enableBackground: "new 0 0 90 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.7,11.2c-1-3.8-4-6.8-7.8-7.8C73,1.6,45.3,1.6,45.3,1.6s-27.7,0-34.6,1.9c-3.8,1-6.8,4-7.8,7.8 C1,18.1,1,32.6,1,32.6S1,47,2.9,53.9c1,3.8,4,6.8,7.8,7.8c6.9,1.9,34.6,1.9,34.6,1.9s27.7,0,34.6-1.9c3.8-1,6.8-4,7.8-7.8 c1.9-6.9,1.9-21.3,1.9-21.3S89.6,18.1,87.7,11.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.4,45.8 59.4,32.6 36.4,19.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeRed);
export default __webpack_public_path__ + "static/media/youtube-red.f402840fb448f5e4047852123afe5c09.svg";
export { ForwardRef as ReactComponent };